import { AccountRepository } from '../Repositories/AccountRepository';
import { mapDeleteAccountError } from './AccountErrors';
import { ok, err, Result } from 'neverthrow';

export class DeleteAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(id: number): Promise<Result<void, string>> {
    return this.repo
      .deleteAccount(id)
      .then(() => ok<void, string>(undefined))
      .catch(e => err<void, string>(mapDeleteAccountError(e).message));
  }
}
